import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { DateHelper } from "@/Common/Helpers/DateHelper";
import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";

export class WalkmeMetadataModel {
    public employeeId: string;
    public language: string;
    public country: string;
    public state: string;
    public clientTag: string;
    public role: string;
    public title: string;
    public walkmeActivationDate: string;
    public userCreationDate: string;
    public goLiveDate: string;
    public type: "Pharmacy" | "Clinic";
    public currentUserAdministrationPermissions: string;
    public isLinkedToAIScribe: boolean;

    public static Initialize(): void {
        Object.defineProperty(window, "walkmeMetadata", {
            get(): WalkmeMetadataModel {
                if (!sessionStore.isAuthenticated() || !sessionStore.userId)
                    return undefined;
                const currentEmployeeActiveSite = sessionStore.getCurrentEmployee()?.getActiveSite();

                return {
                    employeeId: `${cacheStore.ClientIdentifier}_${sessionStore.userId.toUpperCase()}`,
                    language: sessionStore.locale,
                    country: cacheStore.getCountryByLookupId(currentEmployeeActiveSite?.getCountryLookupId())?.Alpha2Code,
                    state: cacheStore.GetStateCodeFromStateLookupId(currentEmployeeActiveSite?.getStateLookupId()),
                    clientTag: cacheStore.ClinicSettings.Tag,
                    role: EnumHelper.getName(EmployeeType, sessionStore.myleEmployeeType),
                    title: Object.values<LicenceOrganisationRule>(cacheStore.AllLicenseOrganizationRulesById).filter(p => p.Title === sessionStore.myleEmployeeTitle)?.firstOrDefault()?.NameEn.replace(" ", ""),
                    walkmeActivationDate: DateHelper.formatIsoFull(sessionStore.userWalkmeActivationDate),
                    userCreationDate: DateHelper.formatIsoFull(sessionStore.userCreationDate),
                    goLiveDate: DateHelper.formatIsoFull(sessionStore.goLiveDate),
                    type: cacheStore.ClinicSettings.EnablePharmacyOrders ? "Pharmacy" : "Clinic",
                    currentUserAdministrationPermissions: WalkmeMetadataModel.getCurrentUserAdministrationPermissionsFormatted().join(),
                    isLinkedToAIScribe: cacheStore.ClinicSettings.EnableAIScribe && !!aiScribeStore?.Model?.get("AIScribeLinkedUser")
                };
            },
            configurable: true
        });
    }

    public static getCurrentUserAdministrationPermissionsFormatted(): string[] {
        const adminPrefix = "Administration_";
        const permissionSuffix = "TabPermission";

        const permissions = sessionStore.userPermissions
            .filter(p => p.contains(adminPrefix));

        return permissions?.map(p => p.slice(adminPrefix.length, p.length - permissionSuffix.length));
    }
}
